<apex-page-info>
  <ng-container title>
    <T str="Agreements"></T>
  </ng-container>
</apex-page-info>

<ng-container *ngIf="agreements">
  <section class="list-container am">
    <mat-nav-list class="mat-elevation-z2 am">
      <ng-container *ngFor="let agreement of agreements">
        <mat-list-item
          lines="3"
          [routerLink]="['/tenancy', tenancyId, 'agreement', agreement.id]">
          <span
            matListItemTitle
            *ngIf="agreement.name"
            [innerHTML]="agreement.name"></span>

          <span
            *ngIf="agreement.objectName"
            matListItemLine
            [innerHTML]="agreement.objectName">
          </span>

          <span matListItemLine>
            <span [matTooltip]="'Period' | translate">
              {{ agreement?.from | dater | date: 'shortDate' }} - {{ agreement?.to | dater | date: 'shortDate' }}
            </span>
          </span>

          <span matListItemMeta>
            <ng-container *ngIf="agreement.active">
              <mat-icon
                matListItemIcon
                class="success-color"
                [matTooltip]="'Active' | translate">
                check_circle
              </mat-icon>
            </ng-container>
          </span>
        </mat-list-item>
      </ng-container>
    </mat-nav-list>
  </section>
</ng-container>
